import { http } from '../../config/axios'

export default function patchFaturaIncobravel(id: string): Promise<string> {
    return http.patch('/api/fatura/incobravel/' + id)
        .then((r) => r.data)
        .catch((error) => {
            console.error('Erro ao marcar fatura como incobrável')
            throw error
        })
}
